import { Component, Input } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Quiz } from '../../DTO/Quiz';
import { QuizService } from '../../Service/Quizservice';
import { Router, UrlSerializer } from "@angular/router";

@Component({
  selector: "submitted-page",
  templateUrl: "./submitted.page.html",
  styleUrls: ["../app.component.css"],
})
export class SubmittedComponent {
  message: string = 'Quiz Already Submitted';
  username;studentid;issubmitted;
  constructor() { }

  ngOnInit() {
    this.username=sessionStorage.getItem('studname') ;
    this.studentid=sessionStorage.getItem("sid");
    this.issubmitted=sessionStorage.getItem("issubmitted");
    window.history.forward();
    document.getElementById("btnGroupDrop1").innerText=this.username;
  }
}
